var _path, _g, _g2, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEarlyBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11H16V21.1315C16 21.9302 15.1099 22.4066 14.4453 21.9635L12.5547 20.7031C12.2188 20.4792 11.7812 20.4792 11.4453 20.7031L9.5547 21.9635C8.89014 22.4066 8 21.9302 8 21.1315V11Z",
    fill: "#94CAFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3924_13973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3898 2.46993C11.7495 2.19295 12.2505 2.19295 12.6102 2.46993L13.6079 3.23831C13.8059 3.39084 14.0539 3.46367 14.303 3.44242L15.5578 3.33542C16.01 3.29684 16.4316 3.56774 16.5844 3.99518L17.0083 5.18099C17.0924 5.41638 17.2617 5.61173 17.4827 5.72852L18.5961 6.31686C18.9975 6.52894 19.2056 6.98473 19.1031 7.42692L18.8186 8.65366C18.7621 8.89719 18.7989 9.15303 18.9217 9.37078L19.5403 10.4677C19.7632 10.8631 19.6919 11.359 19.3666 11.6756L18.464 12.5538C18.2849 12.7281 18.1775 12.9632 18.1631 13.2128L18.0904 14.47C18.0642 14.9232 17.7361 15.3019 17.2913 15.3923L16.0572 15.6431C15.8122 15.6929 15.5948 15.8326 15.4477 16.0348L14.7069 17.0531C14.4399 17.4202 13.9591 17.5614 13.536 17.397L12.3622 16.9408C12.1292 16.8502 11.8708 16.8502 11.6378 16.9408L10.464 17.397C10.0409 17.5614 9.56011 17.4202 9.29308 17.0531L8.55227 16.0348C8.40521 15.8326 8.18777 15.6929 7.94279 15.6431L6.70873 15.3923C6.26389 15.3019 5.93576 14.9232 5.90957 14.47L5.83692 13.2128C5.8225 12.9632 5.71513 12.7281 5.53596 12.5538L4.63341 11.6756C4.30807 11.359 4.23676 10.8631 4.45973 10.4677L5.07831 9.37078C5.20111 9.15303 5.23789 8.89719 5.18142 8.65366L4.89693 7.42692C4.79438 6.98473 5.00254 6.52894 5.40388 6.31686L6.51728 5.72852C6.73831 5.61173 6.90758 5.41638 6.99173 5.18099L7.41563 3.99518C7.56843 3.56774 7.98996 3.29684 8.44224 3.33542L9.69698 3.44242C9.94606 3.46367 10.1941 3.39084 10.3921 3.23831L11.3898 2.46993Z",
    fill: "url(#paint0_linear_3924_13973)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3924_13973)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 5,
    fill: "url(#paint1_linear_3924_13973)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 3,
    fill: "url(#paint2_linear_3924_13973)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3924_13973",
    x: 3.33075,
    y: 1.26221,
    width: 17.3385,
    height: 17.2026,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3924_13973"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3924_13973",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3924_13973",
    x: 6,
    y: 4,
    width: 12,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3924_13973"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3924_13973",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3924_13973",
    x1: 19.5,
    y1: -0.499999,
    x2: 5,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4093E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3924_13973",
    x1: 18,
    y1: 3.5,
    x2: 7.5,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94CAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3924_13973",
    x1: 14.8125,
    y1: 6.0625,
    x2: 9.375,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77B8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2271BF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarlyBadge);
export default __webpack_public_path__ + "static/media/earlyBadge.9bbae0c7e4bf1b7c16a5a96a0833bd05.svg";
export { ForwardRef as ReactComponent };